import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import ReactQuill from "react-quill";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Autocomplete } from "@mui/material";
import InputForm from "../../Form/EditForm/EditInputForm";

function EditGenerateRegistrationLinkForm() {
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();
  const { rowId } = useParams();
  const location = useLocation();
  const code = location.state?.code;

  const [formType, setFormType] = useState("text");

  const initialQuillData = {
    value: null,
    type: formType,
    required: false,
  };

  const [quillData, setQuillData] = useState([initialQuillData]);

  const [exams, setExams] = useState();
  const [selectedExamId, setSelectedExamId] = useState();

  const [document, setDocument] = useState({
    uploadidproof: false,
    uploaddobproof: false,
    uploadphoto: false,
    livephoto: false,
    upload1012certificate: false,
    uploadsignature: false,
    uploadrightthumb: false,
    uploadleftthumb: false,
    liverightthumb: false,
    liveleftthumb: false,
  });

  const [instructionData, setinstructionData] = useState();
  const [formFeesContent, setFormFeesContent] = useState();
  console.log("instructionData", instructionData);

  const [formModules, setFormModules] = useState({
    instruction: true,
    personaldetails: true,
    qualificationdetails: true,
    communicationdetails: true,
    additionaldetails: false,
    centreselection: false,
    uploaddocuments: true,
    applicationpreview: true,
    payexamfee: false,
    applicationstatus: true,
    postselection: false,
    employmentdetails: false,
    name: "",
    exam_id: "",
    form_fees: null,
    your_payment_gateway: "no",
    razorpay_api_key: "",
    razorpay_api_secret: "",
  });

  const quillModules = {
    toolbar: [
      [
        "bold",
        "italic",
        "underline",
        "strike",
        { script: "sub" },
        { script: "super" },
        { color: [] },
        { background: [] },
      ],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["code-block"],
    ],
  };

  const quillFormats = [
    "header",
    "font",
    "size",
    "list",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "link",
    "blockquote",
    "code-block",
    "align",
    "image",
  ];

  const classes = useStyles();

  const handleClose = () => {
    navigate("/admin/registrationlink");
  };

  const handleExamChange = (event, value) => {
    setSelectedExamId(value.id);
  };

  const handleFormSubmit = () => {
    if (!selectedExamId) {
      toast.warn("Please select an exam.");
      return;
    }

    const registration = {
      registration: {
        id: formModules.id,
        name: formModules.name,
        centreselection: formModules.centreselection || false,
        uploaddocuments: formModules.uploaddocuments || false,
        applicationpreview: formModules.applicationpreview || false,
        payexamfee: formModules.payexamfee || false,
        applicationstatus: formModules.applicationstatus || false,
        instruction: formModules.instruction || false,
        personaldetails: formModules.personaldetails,
        qualificationdetails: formModules.qualificationdetails || false,
        postselection: formModules.postselection || false,
        communicationdetails: formModules.communicationdetails || false,
        employmentdetails: formModules.employmentdetails || false,
        additionaldetails: formModules.additionaldetails || false,
        exam_id: selectedExamId, // Use the selected exam ID here
        fields: quillData,
        document: document,
        instruction_content: instructionData,
        form_fees_content: formFeesContent,
        form_fees: formModules.form_fees || null,
        your_payment_gateway: formModules.your_payment_gateway,
        razorpay_api_key: formModules.razorpay_api_key,
        razorpay_api_secret: formModules.razorpay_api_secret,
      },
    };

    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_link`,
        registration,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      )
      .then((response) => {
        const uniqueId = response.data?.registration?.registration_code;
        const link = `https://registration.eduprohub.in/${uniqueId}`;
        toast.success(`Link generated: ${link}`);
        setTimeout(() => {
          navigate("/admin/registrationlink");
        }, 2000);
      })
      .catch((error) => {
        toast.error("Failed to generate link");
        console.error(error);
      });
  };
  // HTML sanitization functions
  const cleanHTML = (html) => {
    if (!html) return html;

    // Remove empty paragraphs and redundant spaces
    return html
      .replace(/<p[^>]*>\s*(<br[^>]*>)?\s*<\/p>/gi, "") // Empty paragraphs
      .replace(/(<[^>]+>)\s+(?=<)/g, "$1") // Spaces between tags
      .replace(/(>)\s+(<)/g, "$1$2") // Spaces between adjacent tags
      .replace(/\s{2,}/g, " ") // Multiple spaces
      .replace(/&nbsp;/g, " ") // Non-breaking spaces
      .trim();
  };

  const normalizeQuillHTML = (html) => {
    if (!html) return html;
    return html
      .replace(/<p[^>]*>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ul>)/gi, "") 
      .replace(/<p[^>]*>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ol>)/gi, "")
      .replace(/(<\/li>)\s*<p[^>]*>(\s*)<\/p>/gi, "$1") 
      .replace(/<p>\s*<br>\s*<\/p>/gi, ""); 
  };
  const fetchDataFromAPI = async (rowId) => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_link/registration/${rowId}`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      if (response.status === 200) {
        const data = response.data.registration;
        console.log("data22222", data);
        setFormModules({
          ...formModules,
          id: data.id || "",
          name: data.name || "",
          centreselection: data.centreselection || "",
          uploaddocuments: data.uploaddocuments || "",
          applicationpreview: data.applicationpreview || "",
          payexamfee: data.payexamfee || "",
          applicationstatus: data.applicationstatus || "",
          instruction: data.instruction || "",
          personaldetails: data.personaldetails || "",
          qualificationdetails: data.qualificationdetails || "",
          postselection: data.postselection || "",
          communicationdetails: data.communicationdetails || "",
          employmentdetails: data.employmentdetails || "",
          additionaldetails: data.additionaldetails || "",
          fields: quillData,
          document: document,
          // instruction_content: instructionData,
          form_fees_content: formFeesContent,
          form_fees: data.form_fees || "",
          your_payment_gateway: data.your_payment_gateway || "no",
          razorpay_api_key: data.razorpay_api_key || "",
          razorpay_api_secret: data.razorpay_api_secret || "",
        });
        setSelectedExamId(data.exam_id.id);
        // setinstructionData(
        //   data.instruction_content.replace(/<p><br><\/p>\s*(?=<ul>)/g, "")
        // );
        // setinstructionData(
        //   data.instruction_content.replace(
        //     /<p>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ul>)/gi,
        //     ""
        //   )
        // );
        setinstructionData(
          cleanHTML(normalizeQuillHTML(data.instruction_content))
        );
        setFormFeesContent(
          cleanHTML(normalizeQuillHTML(data.form_fees_content))
        );
        // setFormFeesContent(
        //   data.form_fees_content.replace(
        //     /<p>\s*(<br[^>]*>)?\s*<\/p>\s*(?=<ul>)/gi,
        //     ""
        //   )
        // );
        setDocument(data.documentPermissions);
        const formattedData = data.fields?.map((val, index) => {
          const formattedVal = {
            id: val?.id,
            value: val?.label,
            type: val?.type,
            required: val?.required,
          };
          if (val.options) {
            formattedVal.options = val.options.map((opt, i) => ({
              id: opt?.id,
              value: opt?.option,
            }));
          }
          return formattedVal;
        });
        setQuillData(formattedData);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error fetching data from the API:", error);
    }
  };

  useEffect(() => {
    if (rowId) {
      fetchDataFromAPI(rowId);
    }
  }, [rowId]);

  const fetchExams = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            // Add other headers if needed
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setExams(data.exams);
      } else {
        console.error("Failed to fetch exam data");
      }
    } catch (error) {
      console.error("Error fetching exam data:", error);
    }
  };

  useEffect(() => {
    fetchExams();
  }, []);

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.mt1} ${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.maxh76}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Exam Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Form Name {console.log("formModules", formModules)}{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  value={formModules.name}
                  onChange={(e) =>
                    setFormModules({
                      ...formModules,
                      [e.target.name]: e.target.value,
                    })
                  }
                  type="text"
                  name="name"
                  variant="outlined"
                  required
                  placeholder="Enter Form Name"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  id="state-autocomplete"
                  options={exams || []}
                  // value={selectedExamId || ""}
                  value={exams?.find((sub) => sub.id === selectedExamId) || ""}
                  classes={{ inputRoot: classes.inputRoot }}
                  onChange={handleExamChange}
                  disableClearable
                  getOptionLabel={(option) => option?.exam_name || ""}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Here"
                      variant="outlined"
                    />
                  )}
                  selectOnFocus
                  openOnFocus
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              ></div>
            </div>

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Form Modules
              </Typography>
              <div
                className={`${classes.dflex} ${classes.tablecheckbox} ${classes.flexdirectioncolumn} ${classes.w36}`}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      name="instruction"
                      color="primary"
                      checked={formModules.instruction}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Instruction"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="personaldetails"
                      color="primary"
                      checked={formModules.personaldetails}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Personal Details"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name="qualificationdetails"
                      color="primary"
                      checked={formModules.qualificationdetails}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Qualification Details"
                />

                {/* <FormControlLabel
                  control={
                    <Checkbox
                      name="postselection"
                      color="primary"
                      checked={formModules.postselection}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Post Selection"
                /> */}

                <FormControlLabel
                  control={
                    <Checkbox
                      name="communicationdetails"
                      color="primary"
                      checked={formModules.communicationdetails}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Communication Details"
                />

                {/* <FormControlLabel
                  control={
                    <Checkbox
                      name="employmentdetails"
                      color="primary"
                      checked={formModules.employmentdetails}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Employment Details"
                /> */}
                <FormControlLabel
                  control={
                    <Checkbox
                      name="additionaldetails"
                      color="primary"
                      checked={formModules.additionaldetails}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Additional Details"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.tablecheckbox} ${classes.flexdirectioncolumn} ${classes.w36}`}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      name="centreselection"
                      color="primary"
                      checked={formModules.centreselection}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="City Selection"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name="uploaddocuments"
                      color="primary"
                      checked={formModules.uploaddocuments}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Upload Documents"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name="applicationpreview"
                      color="primary"
                      checked={formModules.applicationpreview}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Application Preview"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name="payexamfee"
                      color="primary"
                      checked={formModules.payexamfee}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Pay Exam Fee"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name="applicationstatus"
                      color="primary"
                      checked={formModules.applicationstatus}
                      disabled
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Application Status"
                />
              </div>
            </div>
          </div>
          {formModules.instruction && (
            <div
              className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
            >
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >
                  Instruction
                </Typography>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75} ${classes.quillEditorOverride}`}
                >
                  <ReactQuill
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.quilladdsinglequestion}`}
                    value={instructionData}
                    name="instructioncontent"
                    onChange={(e) => {
                      setinstructionData(e);
                    }}
                    instruction_content
                    modules={quillModules}
                    formats={quillFormats}
                  />
                </div>
              </div>
            </div>
          )}

          {formModules.additionaldetails && (
            <div
              className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
            >
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >
                  Additional Details
                </Typography>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
                >
                  <InputForm
                    quillData={quillData}
                    setQuillData={setQuillData}
                    formType={formType}
                    setFormType={setFormType}
                  />
                </div>
              </div>
            </div>
          )}
          {formModules.uploaddocuments && (
            <div
              className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
            >
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >
                  Upload Documents
                </Typography>
                <div
                  className={`${classes.dflex} ${classes.tablecheckbox} ${classes.flexdirectioncolumn} ${classes.w36}`}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="uploadidproof"
                        color="primary"
                        checked={document.uploadidproof}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload ID Proof"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="uploadphoto"
                        color="primary"
                        checked={document.uploadphoto}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload Photo"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="upload1012certificate"
                        color="primary"
                        checked={document.upload1012certificate}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload 10th/10+2 Certificate"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="uploadrightthumb"
                        color="primary"
                        checked={document.uploadrightthumb}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload Right Thumb"
                  />
                  {/* <FormControlLabel
                    control={
                      <Checkbox
                        name="liverightthumb"
                        color="primary"
                        checked={document.liverightthumb}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Live Right Thumb"
                  /> */}
                </div>
                <div
                  className={`${classes.dflex} ${classes.tablecheckbox} ${classes.flexdirectioncolumn} ${classes.w36}`}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="uploaddobproof"
                        color="primary"
                        checked={document.uploaddobproof}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload DOB Proof"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="livephoto"
                        color="primary"
                        checked={document.livephoto}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload Live Photo"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        name="uploadsignature"
                        color="primary"
                        checked={document.uploadsignature}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload Signature"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        name="uploadleftthumb"
                        color="primary"
                        checked={document.uploadleftthumb}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Upload Left Thumb"
                  />
                  {/* <FormControlLabel
                    control={
                      <Checkbox
                        name="liveleftthumb"
                        color="primary"
                        checked={document.liveleftthumb}
                        onChange={(e) =>
                          setDocument({
                            ...document,
                            [e.target.name]: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Live Left Thumb"
                  /> */}
                </div>
              </div>
            </div>
          )}
          {formModules.payexamfee && (
            <div
              className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
            >
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >
                  Form Fees Content
                </Typography>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
                >
                  <ReactQuill
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.quilladdsinglequestion}`}
                    value={formFeesContent}
                    name="form_fees_content"
                    onChange={(e) => {
                      setFormFeesContent(e);
                    }}
                    instruction_content
                    modules={quillModules}
                    formats={quillFormats}
                  />
                </div>
              </div>
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >
                  Payment
                </Typography>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Form Fees <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  <TextField
                    value={formModules.form_fees}
                    onChange={(e) =>
                      setFormModules({
                        ...formModules,
                        [e.target.name]: e.target.value,
                      })
                    }
                    type="number"
                    name="form_fees"
                    variant="outlined"
                    required
                    placeholder="Enter Form Fees"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Your Payment Gateway{" "}
                    <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  <RadioGroup
                    className={`${classes.radiocolor}`}
                    row
                    aria-label="Question Mark System"
                    name="your_payment_gateway"
                    onChange={(e) =>
                      setFormModules({
                        ...formModules,
                        [e.target.name]: e.target.value,
                      })
                    }
                    value={formModules.your_payment_gateway}
                    // value={questionMarkSystem}
                    // onChange={(e) =>
                    //   handleFormChange("question_mark_system", e.target.value)
                    // }
                  >
                    <FormControlLabel
                      value="yes"
                      control={
                        <Radio
                        // onClick={() => setQuestionMarkSystem("same")}
                        />
                      }
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={
                        <Radio
                        // onClick={() => setQuestionMarkSystem("different")}
                        />
                      }
                      label="No"
                    />
                  </RadioGroup>
                </div>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                ></div>
              </div>
              {formModules.your_payment_gateway === "true" && (
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  >
                    Payment Gateway Config
                  </Typography>

                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Key Id <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      value={formModules.razorpay_api_key}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.value,
                        })
                      }
                      type="text"
                      name="razorpay_api_key"
                      variant="outlined"
                      required
                      placeholder="Enter Here"
                    />
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Key Secret <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      checked={formModules.razorpay_api_secret}
                      onChange={(e) =>
                        setFormModules({
                          ...formModules,
                          [e.target.name]: e.target.value,
                        })
                      }
                      type="text"
                      name="razorpay_api_secret"
                      variant="outlined"
                      required
                      placeholder="Enter Here"
                    />
                  </div>

                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  ></div>
                </div>
              )}
            </div>
          )}

          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              onClick={handleClose}
              className={`${classes.custombtnoutline}`}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default EditGenerateRegistrationLinkForm;
